<div *ngIf="data && data?.length >= 1">
    <chart type="bar" *ngIf="graphData$ | async; let graphData" [data]="graphData" [options]="options"></chart>
</div>
<div class="text-center" *ngIf="!data || (data && data?.length <= 0)">
    <h1>No data to display</h1>
</div>